import React, { useState, useMemo } from 'react';

const GoldCalculator = ({ data, country }) => {
  const [weight, setWeight] = useState('');
  const [karat, setKarat] = useState('21');

  const karatOptions = [
    { value: '24', label: 'عيار 24', priceKey: 'price_gram_24k' },
    { value: '22', label: 'عيار 22', priceKey: 'price_gram_22k' },
    { value: '21', label: 'عيار 21', priceKey: 'price_gram_21k' },
    { value: '18', label: 'عيار 18', priceKey: 'price_gram_18k' },
  ];

  const result = useMemo(() => {
    const selectedKarat = karatOptions.find(k => k.value === karat);
    if (!selectedKarat || !data || !weight || isNaN(weight) || parseFloat(weight) <= 0) {
      return null;
    }
    const pricePerGram = data[selectedKarat.priceKey];
    const w = parseFloat(weight);
    return {
      buyTotal: pricePerGram * w,
      sellTotal: pricePerGram * 1.002 * w,
      pricePerGram,
    };
  }, [weight, karat, data]);

  const formatNum = (num) => {
    if (!num) return '—';
    return new Intl.NumberFormat('en-EG', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(num);
  };

  return (
    <div className="gold-calculator">
      <div className="calculator-header">
        <div className="calculator-icon">🧮</div>
        <div>
          <h2 className="calculator-title">حاسبة قيمة الذهب</h2>
          <p className="calculator-subtitle">احسب قيمة ذهبك بالسعر الحالي للسوق</p>
        </div>
      </div>

      <div className="calculator-body">
        {/* Karat Selector */}
        <div className="calc-field">
          <label className="calc-label">العيار</label>
          <div className="karat-tabs">
            {karatOptions.map(k => (
              <button
                key={k.value}
                className={`karat-tab ${karat === k.value ? 'active' : ''}`}
                onClick={() => setKarat(k.value)}
                type="button"
              >
                {k.label}
              </button>
            ))}
          </div>
        </div>

        {/* Weight Input */}
        <div className="calc-field">
          <label className="calc-label" htmlFor="gold-weight">الوزن بالجرام</label>
          <div className="calc-input-wrapper">
            <input
              id="gold-weight"
              type="number"
              className="calc-input"
              placeholder="مثال: 10"
              min="0"
              step="0.01"
              value={weight}
              onChange={(e) => setWeight(e.target.value)}
              style={{ textAlign: 'right', paddingRight: '16px', paddingLeft: '60px' }}
            />
            <span className="calc-input-suffix">جرام</span>
          </div>
        </div>

        {/* Results */}
        <div className={`calc-results ${result ? 'visible' : ''}`}>
          {result ? (
            <>
              <div className="calc-result-row">
                <span className="calc-result-label">سعر الجرام</span>
                <span className="calc-result-value">
                  {formatNum(result.pricePerGram)}
                  <span className="calc-currency"> {country?.currencySymbol}</span>
                </span>
              </div>
              <div className="calc-divider" />
              <div className="calc-result-row highlight-buy">
                <div className="calc-result-info">
                  <span className="calc-result-label">أنت تشتري</span>
                  <span className="calc-result-hint">سعر الصايغ لما تشتري منه</span>
                </div>
                <span className="calc-result-value large">
                  {formatNum(result.sellTotal)}
                  <span className="calc-currency"> {country?.currencySymbol}</span>
                </span>
              </div>
              <div className="calc-result-row highlight-sell">
                <div className="calc-result-info">
                  <span className="calc-result-label">أنت تبيع</span>
                  <span className="calc-result-hint">سعر الصايغ لما تبيعله</span>
                </div>
                <span className="calc-result-value large">
                  {formatNum(result.buyTotal)}
                  <span className="calc-currency"> {country?.currencySymbol}</span>
                </span>
              </div>
            </>
          ) : (
            <div className="calc-placeholder">
              <span style={{ color: 'var(--color-gold-dark)', fontWeight: '700' }}>✦ أدخل الوزن بالجرام لحساب القيمة</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GoldCalculator;
